module.exports = __webpack_public_path__ + "img/la.7b941c8b.gif";